// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"QN-z","categoryName":"RN-z","categoryNameSearchHeader":"SN-z","categoryContent":"TN-z","bottomAligned":"UN-z","image":"VN-z","imageNoBackground":"WN-z"};